import { useSourceStore } from '@/stores/SourceStore.ts';

export const requestInputSourcesAction = () => {
    if (!window.electronApi) {
        return;
    }

    const hostStore = useSourceStore();
    hostStore.sourcesLoading = true;

    window.electronApi.requestSources();
};
